import {
  SIGNING_PROGRESS_INFORMATION__FETCH_FAILURE,
  SIGNING_PROGRESS_INFORMATION__FETCH_REQUEST,
  SIGNING_PROGRESS_INFORMATION__FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { SigningProgressInformationAction } from '@app/store/signingProgressInformation/actions';

const initialState = false;

export default function reducer(
  state: boolean = initialState,
  action: SigningProgressInformationAction
) {
  switch (action.type) {
    case SIGNING_PROGRESS_INFORMATION__FETCH_REQUEST:
      return true;
    case SIGNING_PROGRESS_INFORMATION__FETCH_FAILURE:
    case SIGNING_PROGRESS_INFORMATION__FETCH_SUCCESS:
      return false;
    default:
      return state;
  }
}
